<template>
  <div v-if="doc">
    <v-tabs dark>
      <v-tabs-slider></v-tabs-slider>

      <v-tab :href="`#tab-${index + 1}`" v-for="(tab, index) in doc.exercisesOrder" :key="`${index + 1}`">{{ tab.title
      }}</v-tab>

      <v-tab-item :value="`tab-${index + 1}`" v-for="(tab, index) in doc.exercisesOrder" :key="tab.id">
        <results-tiles :doc="doc" v-if="tab.slug == 'tiles'" model="tilesExCollection" :key="tab.slug" />
        <results-tiles-survey :doc="doc" v-if="tab.slug == 'tiles-survey'" model="tilesExCollectionSurvey"
          :key="tab.slug" />
        <results-tiles-survey :doc="doc" results-module="extended" v-if="tab.slug == 'tiles-survey-haringey'"
          model="tilesExCollectionSurvey" :key="tab.slug" />
        <results-tiles-survey :doc="doc" results-module="basic" v-if="tab.slug == 'tiles-survey-incipio'"
          model="tilesExCollectionSurvey" :key="tab.slug" />
        <results-tiles :doc="doc" v-if="tab.slug == 'tiles-extended'" model="tilesExCollectionExtended"
          :key="tab.slug" />

        <results-tiles :doc="doc" v-if="tab.slug == 'tiles-future'" model="tilesFutureExCollection" :key="tab.slug" />
        <results-tiles-multiple :doc="doc" v-if="tab.slug == 'tiles-multiple'" model="tilesMultipleExCollection"
          :key="tab.slug" />
        <results-functionality :doc="doc" v-if="tab.slug == 'functionality'" :key="tab.slug" />
        <results-keywords :doc="doc" v-if="tab.slug == 'keywords'" :key="tab.slug" />
        <results-messages :doc="doc" v-if="tab.slug == 'message'" :key="tab.slug" />
        <results-proposition :doc="doc" v-if="tab.slug == 'proposition'" :key="tab.slug" />
        <results-tov :doc="doc" v-if="tab.slug == 'tov'" :key="tab.slug" />
        <results-swot :doc="doc" v-if="tab.slug == 'swot'" :key="tab.slug" />
        <results-service :doc="doc" v-if="tab.slug == 'service'" :key="tab.slug" />
        <results-success :doc="doc" v-if="tab.slug == 'success'" :key="tab.slug" />
        <results-service-user :doc="doc" v-if="tab.slug == 'service-user'" :key="tab.slug" />
        <results-travel :doc="doc" v-if="tab.slug == 'travel'" :key="tab.slug" />
        <results-fly :doc="doc" v-if="tab.slug == 'fly'" :key="tab.slug" />
        <results-archetypes :doc="doc" v-if="tab.slug == 'archetypes'" :key="tab.slug" />
        <results-personas :doc="doc" v-if="tab.slug == 'personas'" :key="tab.slug" />
        <results-groups :doc="doc" v-if="tab.slug == 'groups'" :key="tab.slug" />
        <results-structure :doc="doc" v-if="tab.slug == 'structure'" :key="tab.slug" />
        <results-architecture :doc="doc" v-if="tab.slug == 'architecture'" :key="tab.slug" />
        <results-traffic :doc="doc" v-if="tab.slug == 'traffic'" :key="tab.slug" />
        <results-problem :doc="doc" v-if="tab.slug == 'problem'" :key="tab.slug" />
        <results-empathy :doc="doc" v-if="tab.slug == 'empathy'" :key="tab.slug" />
        <results-in-on-if :doc="doc" v-if="tab.slug == 'isinif'" :key="tab.slug" />
        <results-blocks :doc="doc" v-if="tab.slug == 'blocks'" :key="tab.slug" />
        <results-priority :doc="doc" v-if="tab.slug == 'priority'" :key="tab.slug" />
        <results-museum :doc="doc" v-if="tab.slug == 'museum-of-objects'" :key="tab.slug" />
        <results-benefits :doc="doc" v-if="tab.slug == 'benefits'" :key="tab.slug" />
        <results-benefits :doc="doc" v-if="tab.slug == 'benefits-bl'" lang="exercise_benefits_bl" />
        <results-attributes :doc="doc" v-if="tab.slug == 'attributes'" :key="tab.slug" />

        <results-positioning :doc="doc" v-if="
          tab.slug == 'competition-matrix-2' ||
          tab.slug == 'competition-matrix-ug-2'
        " :slug="tab.slug" :key="tab.slug" />
        <results-stakeholder :doc="doc" v-if="tab.slug == 'stakeholder'" model="stakeholderExCollection"
          lang="exercise_stakeholder" :key="tab.slug" />

        <results-stakeholder-standard :doc="doc" v-if="tab.slug == 'stakeholder-standard'"
          model="stakeholderExCollection" lang="exercise_stakeholder_standard" :key="tab.slug" />

        <results-quadrant :doc="doc" v-if="tab.slug == 'competition'" model="competitionExCollection"
          lang="exercise_competition" :key="tab.slug" />
        <results-quadrant :doc="doc" v-if="tab.slug == 'audience'" model="audienceExCollection" lang="exercise_audience"
          :key="tab.slug" />
        <results-four-corners :doc="doc" v-if="tab.slug == 'four-corners'" :key="tab.slug" />
        <results-culture :doc="doc" v-if="tab.slug == 'culture'" :key="tab.slug" />
        <results-today-tomorrow :doc="doc" v-if="tab.slug == 'tomorrow'" :key="tab.slug" />
        <results-success-pillars :doc="doc" v-if="tab.slug == 'success-pillars'" />
        <results-roll-out :doc="doc" v-if="tab.slug == 'roll-out'" />
      </v-tab-item>
    </v-tabs>
    <bottom-navigation :save="false" :next="false" :prev="false" :gridView="false" :gridToggle="false">
    </bottom-navigation>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  ResultsTiles,
  ResultsTilesMultiple,
  ResultsTilesSurvey,
  ResultsFunctionality,
  ResultsKeywords,
  ResultsMessages,
  ResultsProposition,
  ResultsSwot,
  ResultsTov,
  ResultsService,
  ResultsServiceUser,
  ResultsTravel,
  ResultsFly,
  ResultsArchetypes,
  ResultsPersonas,
  ResultsGroups,
  ResultsStructure,
  ResultsArchitecture,
  ResultsTraffic,
  ResultsProblem,
  ResultsEmpathy,
  ResultsInOnIf,
  ResultsBlocks,
  ResultsPriority,
  ResultsQuadrant,
  ResultsStakeholder,
  ResultsStakeholderStandard,
  ResultsSuccess,
  ResultsSuccessPillars,
  ResultsBenefits,
  ResultsAttributes,
  ResultsPositioning,
  ResultsFourCorners,
  ResultsTodayTomorrow,
  ResultsCulture,
  ResultsMuseum,
  ResultsRollOut,
} from "@/components/results";
const fb = require("@/firebaseConfig.js");
import { BottomNavigation } from "@/components/core";

export default {
  name: "UserResults",
  data() {
    return {
      doc: null,
    };
  },
  components: {
    ResultsTiles,
    ResultsTilesSurvey,
    ResultsTilesMultiple,
    ResultsTov,
    ResultsFunctionality,
    ResultsKeywords,
    ResultsMessages,
    ResultsProposition,
    ResultsSwot,
    ResultsService,
    ResultsServiceUser,
    ResultsTravel,
    ResultsFly,
    ResultsArchetypes,
    ResultsPersonas,
    ResultsGroups,
    ResultsStructure,
    ResultsArchitecture,
    ResultsTraffic,
    ResultsProblem,
    ResultsEmpathy,
    ResultsInOnIf,
    ResultsBlocks,
    ResultsPriority,
    ResultsQuadrant,
    ResultsStakeholder,
    ResultsStakeholderStandard,
    ResultsSuccess,
    ResultsSuccessPillars,
    ResultsBenefits,
    ResultsAttributes,
    BottomNavigation,
    ResultsPositioning,
    ResultsFourCorners,
    ResultsTodayTomorrow,
    ResultsCulture,
    ResultsMuseum,
    ResultsRollOut
  },
  created() {
    const ref = fb.projectsCollection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    const ref = fb.projectsCollection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
};
</script>

<style lang="scss"></style>
